import { render, staticRenderFns } from "./home_project2.vue?vue&type=template&id=a041db86&scoped=true&"
import script from "./home_project2.vue?vue&type=script&lang=js&"
export * from "./home_project2.vue?vue&type=script&lang=js&"
import style0 from "./home_project2.vue?vue&type=style&index=0&id=a041db86&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a041db86",
  null
  
)

export default component.exports